export default "__VITE_ASSET__BajOFs7___"